import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { clientesApi } from '@/data/api/clientesApi';
const KEY = 'clientes';
export function useClientes(filtros) {
    return useQuery({
        queryKey: [KEY, filtros],
        queryFn: () => clientesApi.listar(filtros),
        placeholderData: (previous) => previous,
    });
}
export function useCliente(id) {
    return useQuery({
        queryKey: [KEY, 'detalle', id],
        queryFn: () => clientesApi.ver(id),
        enabled: Boolean(id),
    });
}
export function useCrearCliente() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (v) => clientesApi.crear(v),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useEditarCliente() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ id, values }) => clientesApi.editar(id, values),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useDesactivarCliente() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => clientesApi.desactivar(id),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
export function useAnonimizarCliente() {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: (id) => clientesApi.anonimizar(id),
        onSuccess: () => qc.invalidateQueries({ queryKey: [KEY] }),
    });
}
